var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState } from 'react';
import LoginModule from '../Components/LoginModule';
import { countryNavData, examNavData, firstLevelNavList, resourcesNavData } from '../constant';
import MainNavButton from './MainNavButton';
import SubMenuModal from './SubMenuModal';
var DesktopNavbar = function (_a) {
    var _b = _a.isFixedHeader, isFixedHeader = _b === void 0 ? true : _b, webHeaderWidth = _a.webHeaderWidth, loginFunction = _a.loginFunction;
    var _c = __read(useState(null), 2), activeModal = _c[0], setActiveModal = _c[1];
    var timer = useRef(null);
    var handleModalVisibility = function (userAction, key) {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        if (userAction === 'enter') {
            if (activeModal !== key) {
                setActiveModal(key);
            }
        }
        if (userAction === 'leave') {
            timer.current = setTimeout(function () {
                setActiveModal(null);
            }, 50);
        }
    };
    return (React.createElement("div", { id: "desktop_logged_out_navbar", className: "lfc-w-full lfc-h-desktopHeaderHeight lfc-overflow-hidden" },
        React.createElement("div", { className: "".concat(isFixedHeader ? 'lfc-fixed lfc-z-[800] lfc-top-0 lfc-left-0 lfc-right-0' : '', " lfc-bg-white lfc-border-b !lfc-border-[#E2E2E8] lfc-h-[60px] lfc-overflow-hidden") },
            React.createElement("div", { className: "lfc-w-full lfc-h-full lfc-m-auto lfc-flex lfc-justify-between lfc-items-center lfc-px-8 ".concat(webHeaderWidth ? "lfc-max-w-[".concat(webHeaderWidth, "px]") : 'lfc-max-w-[1264px]') },
                React.createElement("div", { className: "lfc-flex lfc-h-8" },
                    React.createElement("a", { href: "/" },
                        React.createElement("img", { id: "leap_scholar_logo", src: "https://ik.imagekit.io/onsnhxjshmp/LeapScholar/new-header-logo_7i5sVUf9VF.svg", height: 32, width: 165, alt: "leap scholar logo", className: "lfc-cursor-pointer lfc-min-w-[165px] lfc-h-[32px]", loading: "eager" }))),
                React.createElement("div", { className: "lfc-flex lfc-items-center lfc-h-full lfc-gap-6" },
                    React.createElement(MainNavButton, { firstLevelNavList: firstLevelNavList, activeModal: activeModal, handleModalVisibility: handleModalVisibility }),
                    React.createElement("div", { className: "lfc-min-w-[101px]" },
                        React.createElement(LoginModule, { loginFunction: loginFunction }))))),
        React.createElement(SubMenuModal, { modalKey: "countries", isModalOpen: activeModal === 'countries', handleModalVisibility: handleModalVisibility, secondLevelNavData: countryNavData }),
        React.createElement(SubMenuModal, { modalKey: "exams", isModalOpen: activeModal === 'exams', handleModalVisibility: handleModalVisibility, secondLevelNavData: examNavData }),
        React.createElement(SubMenuModal, { modalKey: "resources", isModalOpen: activeModal === 'resources', handleModalVisibility: handleModalVisibility, secondLevelNavData: { resources: resourcesNavData } })));
};
export default DesktopNavbar;
//# sourceMappingURL=index.js.map